import { gql } from 'src/generated/gql';

export const PATIENT_REQUIRES_SCHEDULING_QUERY = gql(`
  query PatientRequiresScheduling($patientId: ID!) {
    patientRequiresScheduling(patientId: $patientId)
  }
`);
